import { Component, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'app-confirm-dialog',
  imports: [CommonModule, DialogComponent],
  template: `
    <app-dialog
      [visible]="visible()"
      [header]="header()"
      [closable]="closable()"
      [dismissableMask]="dismissableMask()"
      (visibleChange)="onVisibleChange($event)"
      (closeEvent)="onClose()">
      <div class="py-4">
        <p class="text-gray-700 dark:text-gray-300">{{ message() }}</p>
      </div>
      <div footer>
        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            (click)="onCancel()"
            [class]="cancelButtonClasses">
            {{ cancelLabel() }}
          </button>
          <button
            type="button"
            (click)="onConfirm()"
            [class]="confirmButtonClasses">
            {{ confirmLabel() }}
          </button>
        </div>
      </div>
    </app-dialog>
  `,
  styles: []
})
export class ConfirmDialogComponent {
  visible = signal(false);
  header = input<string>('Confirm');
  message = input<string>('Are you sure?');
  confirmLabel = input<string>('Confirm');
  cancelLabel = input<string>('Cancel');
  variant = input<'danger' | 'warning' | 'info'>('danger');
  closable = input<boolean>(true);
  dismissableMask = input<boolean>(true);

  confirmEvent = output<void>();
  cancelEvent = output<void>();
  visibleChange = output<boolean>();

  onConfirm(): void {
    this.confirmEvent.emit();
    this.visible.set(false);
    this.visibleChange.emit(false);
  }

  onCancel(): void {
    this.cancelEvent.emit();
    this.visible.set(false);
    this.visibleChange.emit(false);
  }

  onClose(): void {
    this.visible.set(false);
    this.visibleChange.emit(false);
  }

  onVisibleChange(value: boolean): void {
    this.visible.set(value);
    this.visibleChange.emit(value);
  }

  get cancelButtonClasses(): string {
    return 'px-4 py-2 rounded-md font-medium transition-colors duration-200 bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600';
  }

  get confirmButtonClasses(): string {
    const classes = ['px-4', 'py-2', 'rounded-md', 'font-medium', 'transition-colors', 'duration-200', 'text-white'];
    
    if (this.variant() === 'danger') {
      classes.push('bg-red-600', 'hover:bg-red-700', 'dark:bg-red-500', 'dark:hover:bg-red-600');
    } else if (this.variant() === 'warning') {
      classes.push('bg-yellow-600', 'hover:bg-yellow-700', 'dark:bg-yellow-500', 'dark:hover:bg-yellow-600');
    } else {
      classes.push('bg-blue-600', 'hover:bg-blue-700', 'dark:bg-blue-500', 'dark:hover:bg-blue-600');
    }
    
    return classes.join(' ');
  }
}

